// extracted by mini-css-extract-plugin
export default {"myModal":"modalImage_myModal__2-2Np","modalContent":"modalImage_modalContent__dZnmm","active":"modalImage_active__hV8+t"};